//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as api from '~/api/index';

import aboutStock from '~/components/public/about-stock';
import initTime from '~/plugins/initTime';
export default {
  name: 'LiveId',
  components: {
    aboutStock,
  },
  validate({ params }) {
    return /^\d+$/.test(params.id);
  },
  async asyncData({ params, error, $axios }) {
    try {
      const [dtb, news] = await Promise.all([
        $axios(api.getDtbDetail(params.id)),
        $axios(api.getNewsData({ createDate: '', count: 6 })),
      ]);
      if (!dtb?.result) {
        throw new Error(`数据不存在 ID:${params.id}`);
      }
      // 如果股票存在，获取相关股票的详细数据
      let stockList = [];
      let stockNews = [];
      let stockCodeLists = [];
      if (dtb?.result?.stockList?.length > 0) {
        stockList = dtb.result.stockList.map(
          i => `${i.stockType}${i.stockCode}`
        );
        // 获取股票相关的要闻
        stockNews = await Promise.all(
          dtb.result.stockList.map(async item => {
            const stockNewsResult = await $axios(
              api.getStocksNews({
                page: 1,
                count: 2,
                keyword: item.stockCode,
              })
            );
            return stockNewsResult?.result?.newsList ?? [];
          })
        );
      }
      if (stockList.length > 0) {
        const stockCodeListsData = await $axios(
          api.getStocksDetails({
            stockCodes: stockList.join(','),
          })
        );
        stockCodeLists = stockCodeListsData?.result ?? [];
      }
      stockNews = stockNews.flat();
      return {
        dtbDetail: dtb?.result,
        newsData: news?.result ?? [],
        stockCodeLists,
        stockNews,
      };
    } catch (err) {
      error({ statusCode: 404, message: '快讯不存在 - ' + err });
    }
  },

  head() {
    return {
      title: `${
        this.dtbDetail && this.dtbDetail.title ? this.dtbDetail.title : '快讯'
      }-格隆汇`,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content:
            this.dtbDetail && this.dtbDetail.content
              ? this.dtbDetail.content.slice(0, 76)
              : '',
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: `${
            this.dtbDetail && this.dtbDetail.title
              ? this.dtbDetail.title
              : '快讯'
          }`,
        },
      ],
      script: [
        {
          src: 'https://cdn.gelonghui.com/ad/img/20171117/baidupush.js',
        },
      ],
      link: [
        {
          rel: 'canonical',
          href: `https://www.gelonghui.com/live/${
            this.dtbDetail && this.dtbDetail.id ? this.dtbDetail.id : ''
          }`,
        },
        {
          rel: 'alternate',
          media: 'only screen and (max-width:640px)',
          href: `https://m.gelonghui.com/live/${
            this.dtbDetail && this.dtbDetail.id ? this.dtbDetail.id : ''
          }`,
        },
      ],
    };
  },
  methods: {
    initTime(t) {
      return initTime(t);
    },
  },
};
